import React, { useState } from 'react';

import { Box, Collapse, Divider } from '@material-ui/core';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { getTWithPathKey } from 'utils';

import { Button } from './style';

const getT = getTWithPathKey('components.CollapseBox');

export function CollapseBox({ children, openButtonText, closeButtonText }) {
  const [isOpened, setIsOpened] = useState(false);

  const handleClick = () => setIsOpened(prev => !prev);

  const ArrowIcon = () => (isOpened ? <KeyboardArrowUp /> : <KeyboardArrowDown />);
  const buttonText = isOpened ? closeButtonText : openButtonText;

  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Box flex="1 1 auto">
          <Divider />
        </Box>
        <Box p="0 5px">
          <Button size="small" startIcon={<ArrowIcon />} onClick={handleClick}>
            {buttonText}
          </Button>
        </Box>
        <Box flex="1 1 auto">
          <Divider />
        </Box>
      </Box>
      <Collapse in={isOpened}>
        <Box pt="15px">{children}</Box>
      </Collapse>
    </Box>
  );
}

CollapseBox.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({}), PropTypes.array]),
  openButtonText: PropTypes.string,
  closeButtonText: PropTypes.string,
};

CollapseBox.defaultProps = {
  children: null,
  openButtonText: getT('open'),
  closeButtonText: getT('close'),
};
